import { ContactPhoneRounded } from "@material-ui/icons";

const Contact = () => {
  return (
    <div style={
      {
        background: "URL(https://www.teahub.io/photos/full/96-965236_background-color-simple-background-color-full.jpg)",
        backgroundSize: "100% 100%",
        paddingTop: "0",
      }
    }>

      <h5 style={{ fontFamily: "Estinia,sans-serif", fontSize: 36 }}> Krushiphala</h5><p> invites you to embrace your productivity
        The site has been developed to provide information to the general public.
        An attempt has been made through this site to provide reliable, comprehensive, accurate information about
        Department of Information Technology and its various Groups/Organizations. Hyperlinks at various places have
        been provided to other Indian Government Portals/Websites.
      </p>
      <h4>
        Please do provide your feedback to us:
        Fax: +91-11-24301851/862
        Email: webmaster AT.krushipala.agri.in


        Please contact us for the claims or complaints to the app through
        <br />
        Webmaster
        DAC-Website
        Fax: +91-11-24301851/862
        Email: krushipala@gmail.com
      </h4>

    </div>
  );
}
export default Contact;